import { createRoot } from '@wordpress/element';
import { StandAloneSearchPage } from './StandAloneSearchPage.tsx';
import { buildSearchEngine } from '@coveo/headless';
import { default as getCoveoToken } from '../../../assets/js/modules/coveo-utils.js';

document.addEventListener( 'DOMContentLoaded', async ( props ) => {
	if ( document.body.classList.contains( 'search' ) ) {
		return;
	}
	const initialToken = await getCoveoToken();
	const commonConfig = {
		accessToken: initialToken,
		organizationId: COVEO_ORG_ID ?? '',
		renewAccessToken: getCoveoToken,
		analytics: { analyticsMode: 'legacy' },
	};

	Array.from( document.querySelectorAll( '.coveo-standalone-searchbox' ) ).map( function ( container ) {
		if ( container ) {
			props.engine = buildSearchEngine( {
				configuration: commonConfig,
			} );

			for ( const attr of container.attributes ) {
				props[ attr.name ] = attr.value;
			}
			const root = createRoot( container );
			root.render(
				<>
					<StandAloneSearchPage { ...props } />
				</>
			);
		}
	} );
} );
